export const defaultArticleModel = {
    category: '',
    content: '',
    date: '',
    id: 0,
    image: '',
    link: '',
    linkLabel: '',
    title: '',
    slug: '',
    truncateContent: '',
};
export const placeholderArticleModel = {
    category: 'Sample Category',
    content: 'Some Content Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident veniam natus aut ipsam dignissimos, veritatis quae explicabo voluptates animi molestiae soluta totam.',
    date: new Date().toISOString(),
    id: 1,
    image: 'https://placehold.co/400x400/orange/white',
    link: '#-some-link',
    linkLabel: 'More Some Text',
    title: 'Some Title Lorem ipsum dolor sit amet.',
    slug: 'lorem-ipsum-dolor-sit-amet',
    truncateContent: 'Some Content Lorem ipsum dolor sit amet, consectetur adipisicing elit. Provident veniam natus aut...',
};
//# sourceMappingURL=ArticleDefaults.js.map